var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluetoothConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1165",
    "data-name": "Group 1165",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.429,
    height: 20.476,
    viewBox: "0 0 18.429 20.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_bluetooth_connected_24px",
    d: "M7.1,12.238,5.048,10.191,3,12.238l2.048,2.048ZM18.06,7.846,12.214,2H11.191V9.771l-4.7-4.7L5.048,6.515l5.723,5.723L5.048,17.961,6.491,19.4l4.7-4.7v7.771h1.024L18.06,16.63l-4.4-4.392ZM13.238,5.921l1.925,1.925L13.238,9.771ZM15.163,16.63l-1.925,1.925v-3.85l1.925,1.925Zm4.218-6.44-2.048,2.048,2.048,2.048,2.048-2.048Z",
    transform: "translate(-3 -2)",
    fill: "#4ca07a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetoothConnected);
export default __webpack_public_path__ + "static/media/bluetooth-connected.390a90221987df2248446e6a875bad90.svg";
export { ForwardRef as ReactComponent };